export const footer_i18n = {
    text1: "Privacy",
    text2: "Termini",
    text3: "Mappa del sito"
};